const spamDomainList = [
  'gmail.',
  'mail.',
  'heroku.com',
  'aol.com',
  'list.ru',
  'inbox.ru',
  'icloud.com',
  'protonmail.com',
  'comcast.net',
  'naver.com',
  'me.com',
  'bk.',
  'ymail.com',
  'ya.',
  'mac.com',
  'googlemail.com',
  'rambler.',
  'msn.com',
  'urhen.com',
  'mailinator.com',
  'yopmail.com',
  'tuta.io',
  'emltmp.com',
  'email.com',
  'ymail.',
  'newe-mail.com',
  'hxqmail.com',
  'emailnube.com',
  'svpmail.com',
  'fft-mail.com',
  'qq.com',
  '163.com',
  'zzrgg.com',
  '4xmail.net',
  '10mail.org',
  'awdrt.com',
  'emailcu.icu',
  'ttirv.net',
  'xmailweb.com',
  'naver.com',
  'gail.com',
  'gamil.com',
  'gmai.com',
  'gmaio.com',
  'awdrt.org',
  'emlpro.com',
  'yopmail.com',
  'twzhhq.online',
  'cctyoo.com',
  'niwghx.com',
  'wqcefp.com',
  'upived.online',
  'upived.com',
  'twzhhq.com',
  'nodomain.tld',
  'ssr.ias-lab.de',
  'gmx.',
  'hotmail.',
  'yandex.',
  'yahoo.',
  'live.co.',
  'outlook.',
  'gimal.',
  'icloud.',
  'emall.',
  'hotmal.',
  'gami.',
  'gmali.',
  'gamil.c',
  'gmai.c',
  'gmil.com',
  'emal.com',
  'business.com',
  'bisnes.com',
  'work.com',
];

export function checkIsSpam(email: string | undefined): boolean {
  if (!email) {
    return true;
  }

  const domain = email.split('@')?.[1]?.toLowerCase();
  if (!domain) {
    return true;
  }

  return spamDomainList.some((spamDomain) => (
    domain.includes(spamDomain)
  ));
}
